function sortByName(a, b) {
  const aName = a?.name;
  const bName = b?.name;
  if (!aName) {
    if (!bName) {
      return 0;
    }
    return 1;
  } else if (!bName) {
    return -1;
  }
  return a?.name?.localeCompare(b?.name?.toLowerCase() || 'ZZZ');
}

export default sortByName;
